import React from 'react';

import Icon from './square-icons/pdf.png';

const SquarePDFIcon = () => {
  return <img style={{ height: 30, width: 30 }} src={Icon} alt="pdf-icon" />;
};

export default SquarePDFIcon;
